

import React, { useState } from 'react';
import GameData from "../../../components/games/GameData";
import DepositCard from "../../../components/cards/DepositCard";
import "./deposit.css"; // your custom styles

function Deposit() { const [visibleCount, setVisibleCount] = useState(10);

  const handleSeeMore = () => {
    setVisibleCount(GameData.length);
  };

  return (
    <div className="deposit-page-wrapper">
      <div className="text-banner">
        <h1>Deposit</h1>
      </div>

      <section className="deposit-grid">
        {GameData.slice(0, visibleCount).map((game, index) => (
          <DepositCard data={game} key={index} />
        ))}
      </section>

      {visibleCount < GameData.length && (
        <div className="see-more-container">
          <button className="see-more-btn" onClick={handleSeeMore}>
            See More
          </button>
        </div>
      )}
    </div>
  );
}

export default Deposit;

